const state = {
  experienceOptions: [
    '2-5 years', '5-10 years', '10 plus years'
  ],
  commitmentOptions: [
    'Long Term (longer than 1 year)', 'Short Term (1 year or less)', 'Temporary',
  ],
  availabilityOptions: [
    'Full Time', 'Part Time', 'Come and Go', 'Live In'
  ],
  drvingStatuses: [
    'D.L. and Car', 'Driver\'s License only', 'Neither',
  ],
  certificationStatuses: [
    'Yes', 'Willing to get certified', 'No',
  ],
  vaccinationStatuses: [
    'Yes', 'Willing to get', 'No'
  ],
  petsOptions: [
    'Dog', 'Cat', 'Neither',
  ],
  travelOptions: [
    'Domestic', 'International', 'No travel',
  ],
  // activeStatus: 'Profile Complete',
  activeStatus: 'Profile Complete',
  broadcastStatuses: [
    'Interview Complete', 'Profile Complete'
  ],
};

const mutations = {

};

const actions = {

};

const getters = {
  experienceOptions (state) {
    return state.experienceOptions
  },
  commitmentOptions (state) {
    return state.commitmentOptions
  },
  availabilityOptions (state) {
    return state.availabilityOptions
  },
  drvingStatuses (state) {
    return state.drvingStatuses
  },
  certificationStatuses (state) {
    return state.certificationStatuses
  },
  vaccinationStatuses (state) {
    return state.vaccinationStatuses
  },
  petsOptions (state) {
    return state.petsOptions
  },
  travelOptions (state) {
    return state.travelOptions
  },
  activeStatus (state) {
    return state.activeStatus
  },
  broadcastStatuses (state) { // Which candidate statuses receive job broadcasts
    return state.broadcastStatuses
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/candidates.js